var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83268 0.354492C4.28719 0.354492 0.584473 4.0572 0.584473 8.60272C0.584473 13.1482 4.28719 16.8581 8.83268 16.8581C10.7742 16.8581 12.5598 16.1777 13.971 15.048L17.4067 18.4819C17.5801 18.6481 17.8117 18.7398 18.0519 18.7374C18.292 18.7349 18.5217 18.6385 18.6916 18.4688C18.8616 18.2991 18.9583 18.0696 18.9611 17.8295C18.9639 17.5893 18.8725 17.3576 18.7065 17.184L15.2708 13.7483C16.4015 12.3349 17.0827 10.5465 17.0827 8.60272C17.0827 4.0572 13.3782 0.354492 8.83268 0.354492ZM8.83268 2.18785C12.3874 2.18785 15.2476 5.04804 15.2476 8.60272C15.2476 12.1574 12.3874 15.0248 8.83268 15.0248C5.278 15.0248 2.41781 12.1574 2.41781 8.60272C2.41781 5.04804 5.278 2.18785 8.83268 2.18785Z",
    fill: "#122A54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.427c8b6a7e21216a09e650b4cc93510a.svg";
export { ForwardRef as ReactComponent };